import React, { FC, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

interface AuthCheckProps {
  children: React.ReactNode
}

const AuthCheck: FC<AuthCheckProps> = ({ children }) => {
  const navigate = useNavigate()

  const authStateString = sessionStorage.getItem('authState') || localStorage.getItem('authState')
  const authStateObject = authStateString ? JSON.parse(authStateString) : null
  const accessToken = authStateObject?.user?.accessToken
  useEffect(() => {
    if (!accessToken) {
      navigate('/login')
    }
  }, [accessToken, navigate])

  return accessToken ? children : null
}

export default AuthCheck
